import React,{useEffect} from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MembersMain from './MembersMain';

const Members = () => {
    useEffect(() => {
      document.title = "Members | Society of Aquaculture Professionals";
    }, []);
  return (
    <div>
      <>
        <MembersMain />
        
        <Footer />
      </>
    </div>
  );
};
export default Members;